//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody,Input, Row, Col} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const garageTypeEnum = [
  {value:'ATTACHED_GARAGE', label:'Attached Garage'},
  {value:'DETACHED_GARAGE', label:'Detached Garage'},
  {value:'BUILTIN_GARAGE', label:'Builtin Garage'},
  {value:'NONE', label:'None'},
]

const garageDeficiencyNameEnum = [
  {value:'NONE_OBSERVED', label:'None Observed'},
  {value:'SIDING', label:'Siding'},
  {value:'WINDOWS', label:'Windows'},
  {value:'DOORS', label:'Doors'},
  {value:'GARAGE_DOOR', label:'Garage Door'},
  {value:'EXTERIOR_WALLS', label:'Exterior Walls'},
  {value:'INTERIOR_WALLS', label:'Interior Walls'},
  {value:'CEILING', label:'Ceiling'},
  {value:'ROOF', label:'Roof'},
  {value:'FOUNDATION', label:'Foundation'},
  {value:'OTHER', label:'Other'},
]

const garageDeficiencyTypeEnum = [
  {value:'EXCESSIVE_WEAR', label:'Excessive Wear'},
  {value:'EVIDENCE_OF_INFESTATION', label:'Evidence of Infestation'},
  {value:'MISSING', label:'Missing'},
  {value:'OTHER', label:'Other'},
]

const garageDeficiencyDetailFoundationEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'},
  {value:'CRACKING', label:'Cracking'},
  {value:'SETTLEMENT', label:'Settlement'},
  {value:'EVIDENCE_OF_MOISTURE', label:'Evidence of Moisture'},
  {value:'SEEPAGE', label:'Seepage'},
  {value:'INFESTATION', label:'Infestation'},
  {value:'LEANING_OR_BOWED_WALLS', label:'Leaning or Bowed Walls'},
  {value:'HEAVING', label:'Heaving'},
  {value:'OTHER', label:'Other'}
]

const garageDeficiencyDetailExteriorWallsEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'},
  {value:'CRACKING', label:'Cracking'},
  {value:'HOLES', label:'Holes'},
  {value:'DRY_ROT', label:'Dry Rot'},
  {value:'MOISTURE_ROT', label:'Moisture Rot'},
  {value:'SETTLEMENT', label:'Settlement'},
  {value:'WIND_DAMAGE', label:'Wind Damage'},
  {value:'MISSING_MATERIAL', label:'Missing Material'},
  {value:'OTHER', label:'Other'},
]

const garageDeficiencyDetailRoofSurfaceEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'},
  {value:'CRACKING', label:'Cracking'},
  {value:'TARP_ON_ROOF', label:'Tarp on Roof'},
  {value:'LEAK_EVIDENT', label:'Leak Evident'},
  {value:'MISSING_MATERIAL', label:'Missing Material'},
  {value:'WOOD_ROT', label:'Wood Rot'},
  {value:'SOFFIT_DAMAGE', label:'Soffit Damage'},
  {value:'FASCIA_DAMAGE', label:'Fascia Damage'},
  {value:'OTHER', label:'Other'},
]

const garageDeficiencyDetailWindowsEnum = [
  {value:'CRACKING', label:'Cracking'},
  {value:'MISSING_WINDOW_PANE', label:'Missing Window Pane'},
  {value:'EXPOSED_WOOD', label:'Exposed Wood'},
  {value:'STORM_SASH_DAMAGE', label:'Storm Sash Damage'},
  {value:'THERMOPANE_DAMAGE', label:'Thermopane Damage'},
  {value:'OTHER', label:'Other'}
]

const garageDeficiencyDetailCeilingEnum = [
  {value:'DISCOLORATION', label:'Discoloration'},
  {value:'MISSING', label:'Missing'},
  {value:'CRUMBLING', label:'Crumbling'},
  {value:'WATER_DAMAGE', label:'Water Damage'},
  {value:'OTHER', label:'Other'}
]

const garageDeficiencyDetailInteriorWallsEnum = [
  {value:'DISCOLORATION', label:'Discoloration'},
  {value:'MISSING', label:'Missing'},
  {value:'CRUMBLING', label:'Crumbling'},
  {value:'WATER_DAMAGE', label:'Water Damage'},
  {value:'OTHER', label:'Other'},
]

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const Garages  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const numberOnly= (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
  };
  
  const getGarageDeficiencyDetailLabel = (value, type)=>{
    let detailEnum = [];

    if(type === 'foundation'){
      detailEnum = garageDeficiencyDetailFoundationEnum;
    }else if(type === 'exterior_wall'){
      detailEnum = garageDeficiencyDetailExteriorWallsEnum;
    }else if(type === 'roof'){
      detailEnum = garageDeficiencyDetailRoofSurfaceEnum;
    }else if(type === 'interior_wall'){
      detailEnum = garageDeficiencyDetailInteriorWallsEnum;
    }else if(type === 'ceiling'){
      detailEnum = garageDeficiencyDetailCeilingEnum;
    }else if(type === 'window'){
      detailEnum = garageDeficiencyDetailWindowsEnum;
    }

    console.log(detailEnum);

    for(let i=0;i<detailEnum.length;i++){
      if(detailEnum[i].value===value)
        return detailEnum[i].label;
    }

    return value;
  }

  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let garages = newUPD.property.buildings[props.index].units[props.index2].garages.slice();
    let target = garages[index][field]?garages[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].garages = garages;
    props.update(newUPD);
  }

  const updateFileDescription2 = (index, index2, index3, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice();
    let target = garageDeficiencies[index2][field]?garageDeficiencies[index2][field]:[];
    if(target &&  target[index3]){
      target[index3].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
    props.update(newUPD);
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let garages = newUPD.property.buildings[props.index].units[props.index2].garages.slice();
   
                let target = garages[index][field]?garages[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:garages[index].ID, description:description});
                garages[index][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].garages = garages;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop2 = (acceptedFiles, rejectedFiles, index, index2, field, type='Misc', typeFk=0, description='')=>{

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice();
   
                let target = garageDeficiencies[index2][field]?garageDeficiencies[index2][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:garageDeficiencies[index2].ID, description:description});
                garageDeficiencies[index2][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let garages = newUPD.property.buildings[props.index].units[props.index2].garages.slice();
    let target = garages[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        garages[index][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].garages = garages;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      garages[index][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].garages = garages;
      props.update(newUPD);
    }
  }

  const removeFile2 = (field,index, index2, index3)=>{
    let newUPD = Object.assign({}, props.upd);
    let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice();
    let target = garageDeficiencies[index2][field].slice();

    let targetToDelete = target[index3];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index3, 1);
        garageDeficiencies[index2][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index3, 1);
      garageDeficiencies[index2][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
      props.update(newUPD);
    }
  }

  const getGarageTypeLabel = (value)=>{
    for(let i=0;i<garageTypeEnum.length;i++){
      if(garageTypeEnum[i].value===value)
        return garageTypeEnum[i].label;
    }
    return value;
  }

  const getGarageDeficiencyNameLabel = (value)=>{
    for(let i=0;i<garageDeficiencyNameEnum.length;i++){
      if(garageDeficiencyNameEnum[i].value===value)
        return garageDeficiencyNameEnum[i].label;
    }
    return value;
  }

  const removeGarage = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let garages = newUPD.property.buildings[props.index].units[props.index2].garages?newUPD.property.buildings[props.index].units[props.index2].garages.slice():null;
    garages.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].garages = garages;
    props.update(newUPD);
  }

  const removeGarageDeficiency = (index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies?newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice():null;
    garageDeficiencies.splice(index2, 1);
    newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
    props.update(newUPD);
  }

  const updateGarageDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let garages = newUPD.property.buildings[props.index].units[props.index2].garages?newUPD.property.buildings[props.index].units[props.index2].garages.slice():null;
    garages[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].garages = garages;
    props.update(newUPD);
  }

  const removeGarageDeficienciesDetail = (index, index2, index3, field)=>{
    let newUPD = Object.assign({}, props.upd);
    let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies?newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice():null;
    let target = garageDeficiencies[index2][field].slice();
    target.splice(index3, 1);
    garageDeficiencies[index2][field] = target;
    newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
    props.update(newUPD);
  }

  const updateGarageDeficiencyDetail = (index, index2, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies?newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice():null;
   
    switch(field){
      case 'garageDeficiencyDetailFoundation':
      case 'garageDeficiencyDetailExteriorWalls':
      case 'garageDeficiencyDetailRoofSurface':
      case 'garageDeficiencyDetailWindows':
      case 'garageDeficiencyDetailCeiling':
      case 'garageDeficiencyDetailInteriorWalls':
        let target = garageDeficiencies[index2][field]?garageDeficiencies[index2][field].slice():[];
        if(target.indexOf(value)===-1)
          target.push(value);
          garageDeficiencies[index2][field] = target;
        break;
      default:
        garageDeficiencies[index2][field] = value;
        break;
    }
    console.log(garageDeficiencies)
    newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
    props.update(newUPD);
  }

  const updateGarage = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let garages = newUPD.property.buildings[props.index].units[props.index2].garages?newUPD.property.buildings[props.index].units[props.index2].garages.slice():null;
    
    if(value==='NONE'){
      garages = [{garageType:'NONE', garageDeficiencies:[], imageOutsideGarage:[], imageInsideGarage:[]}];
    }
    else{
      for(let i=0;i<garages.length;i++){
        if(garages[i].garageType==='NONE')
          garages = [];
      }
      garages.push({garageType:value, garageDeficiencies:[], imageOutsideGarage:[], imageInsideGarage:[]});
    }

    newUPD.property.buildings[props.index].units[props.index2].garages = garages;
    props.update(newUPD);
  }

  const updateGarageDeficiency = (index, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let garageDeficiencies = newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies?newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies.slice():null;
    
    if(value==='NONE_OBSERVED'){
      garageDeficiencies = [{garageDeficiencyName:'NONE_OBSERVED'}];
    }
    else{
      for(let i=0;i<garageDeficiencies.length;i++){
        if(garageDeficiencies[i].garageDeficiencyName==='NONE_OBSERVED')
          garageDeficiencies = [];
      }
      garageDeficiencies.push({garageDeficiencyName:value, imageGarageDeficiency:[]});
    }

    newUPD.property.buildings[props.index].units[props.index2].garages[index].garageDeficiencies = garageDeficiencies;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return <div>
    <label>{!props.disabled?<font color="red">*</font>:null}What type of garage is available on this site? {generateTooltip('garageType', 'User to select all applicable parking types within the structure. A built-in garage is car storage that is attached to a dwelling structure that has living area above it. An attached garage shares a common wall with a dwelling structure and has no living area above the garage. ')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].garages && props.upd.property.buildings[props.index].units[props.index2].garages.length>0?" ":""}
      onChange={(v)=>updateGarage(v)}
      options={garageTypeEnum}
    />
    {props.upd.property.buildings[props.index].units[props.index2].garages.map(
      (garage, index)=>{
        console.log(garage)
        if(garage.garageType==='NONE'){
          return <div key={index} style={{marginTop:'15px'}}>
            <b>None</b>
          </div>
        }
        return (
          <div keyt={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarage(index)}/> {getGarageTypeLabel(garage.garageType)} </CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}How many parking spaces are available for this garage type? {generateTooltip('garageSpaceCount'+index, 'User to select all applicable parking types within the structure. A built-in garage is car storage that is attached to a dwelling structure that has living area above it. An attached garage shares a common wall with a dwelling structure and has no living area above the garage.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={garage.garageSpaceCount} onChange={(e)=>updateGarageDetail(index,'garageSpaceCount', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}What is the area (in square feet) of the garage space from external measurements? {generateTooltip('garageSpaceArea'+index, 'User to input the area in square feet for covered parking types. Area should be consistent with the floor plan.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={garage.garageSpaceArea} onChange={(e)=>updateGarageDetail(index,'garageSpaceArea', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Has the garage been converted to finished area? {generateTooltip('mechanicalDeficiencySeverity'+index,'User to indicate whether the garage was converted to finished area. Possible indicators of a garage conversion: 1. Garage door may have been removed or modified. 2. Garage has been improved with finishes such as drywall, flooring, heating/cooling, etc. 3. Converted space has permanent heating and/or cooling. True = garage was converted. False = garage is utilized car storage or original use, not converted.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={garage.garageConversionIndicator}
                  onChange={(v)=>updateGarageDetail(index, 'garageConversionIndicator', v)}
                  options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                />
                <br/>

                <label>{!props.disabled?<font color="red">*</font>:null}What are the garage item(s) / component(s) with damage or wear that require repairs? {generateTooltip('garageDeficiencyName', 'User to identify any garage item(s) / component(s) that are either damaged or show obvious signs of wear that require repairs. User should select \'None Observed\' if no signs of damage are apparent.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={garage.garageDeficiencies && garage.garageDeficiencies.length>0?" ":""}
                  onChange={(v)=>updateGarageDeficiency(index, v)}
                  options={garageDeficiencyNameEnum}
                />

                {garage.garageDeficiencies.map(
                  (garageDeficiency, index2)=>{
                    if(garageDeficiency.garageDeficiencyName==='NONE_OBSERVED'){
                      return <div key={index} style={{marginTop:'15px'}}>
                        <b>None Observed</b>
                      </div>
                    }
                    return <div key={index2}>
                      <Card>
                        <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficiency(index, index2)}/>{getGarageDeficiencyNameLabel(garageDeficiency.garageDeficiencyName)} </CardHeader>
                        <CardBody>
                          <label>{!props.disabled?<font color="red">*</font>:null}What type of damage or wear did you observe? {generateTooltip('garageDeficiencyType'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyType}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyType', v)}
                            options={garageDeficiencyTypeEnum}
                          />
                          <br/>
                          {garageDeficiency.garageDeficiencyName==='FOUNDATION'?<div><label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected. {generateTooltip('garageDeficiencyDetailFoundation'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyDetailFoundation}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyDetailFoundation', v)}
                            options={garageDeficiencyDetailFoundationEnum}
                          />
                          <br/>
                          {
                            garageDeficiency.garageDeficiencyDetailFoundation?garageDeficiency.garageDeficiencyDetailFoundation.map(
                              (detail, index3)=>{
                                return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficienciesDetail(index, index2, index3, 'garageDeficiencyDetailFoundation')}/> {getGarageDeficiencyDetailLabel(detail, 'foundation')}
                                </span>
                              }
                            ):null
                          }
                          </div>
                          :null}

                          {garageDeficiency.garageDeficiencyName==='EXTERIOR_WALLS'?<div><label>{!props.disabled?<font color="red">*</font>:null}What signs of damange or wear were observed for the item / component selected. {generateTooltip('garageDeficiencyDetailExteriorWalls'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyDetailExteriorWalls}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyDetailExteriorWalls', v)}
                            options={garageDeficiencyDetailExteriorWallsEnum}
                          />
                          <br/>
                          {
                            garageDeficiency.garageDeficiencyDetailExteriorWalls?garageDeficiency.garageDeficiencyDetailExteriorWalls.map(
                              (detail, index3)=>{
                                return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficienciesDetail(index, index2, index3, 'garageDeficiencyDetailExteriorWalls')}/> {getGarageDeficiencyDetailLabel(detail, 'exterior_wall')}
                                </span>
                              }
                            ):null
                          }
                          </div>
                          :null}

                          {garageDeficiency.garageDeficiencyName==='ROOF'?<div><label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected. {generateTooltip('garageDeficiencyDetailRoofSurface'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyDetailRoofSurface}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyDetailRoofSurface', v)}
                            options={garageDeficiencyDetailRoofSurfaceEnum}
                          />
                          <br/>
                          {
                            garageDeficiency.garageDeficiencyDetailRoofSurface?garageDeficiency.garageDeficiencyDetailRoofSurface.map(
                              (detail, index3)=>{
                                return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficienciesDetail(index, index2, index3, 'garageDeficiencyDetailRoofSurface')}/> {getGarageDeficiencyDetailLabel(detail, 'roof')}
                                </span>
                              }
                            ):null
                          }
                          </div>
                          :null}

                          {garageDeficiency.garageDeficiencyName==='WINDOWS'?<div><label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected. {generateTooltip('garageDeficiencyDetailWindows'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyDetailWindows}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyDetailWindows', v)}
                            options={garageDeficiencyDetailWindowsEnum}
                          />
                          <br/>
                          {
                            garageDeficiency.garageDeficiencyDetailWindows?garageDeficiency.garageDeficiencyDetailWindows.map(
                              (detail, index3)=>{
                                return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficienciesDetail(index, index2, index3, 'garageDeficiencyDetailWindows')}/> {getGarageDeficiencyDetailLabel(detail, 'window')}
                                </span>
                              }
                            ):null
                          }
                          </div>
                          :null}

                          {garageDeficiency.garageDeficiencyName==='CEILING'?<div><label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected. {generateTooltip('garageDeficiencyDetailCeiling'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyDetailCeiling}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyDetailCeiling', v)}
                            options={garageDeficiencyDetailCeilingEnum}
                          />
                          <br/>
                          {
                            garageDeficiency.garageDeficiencyDetailCeiling?garageDeficiency.garageDeficiencyDetailCeiling.map(
                              (detail, index3)=>{
                                return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficienciesDetail(index, index2, index3, 'garageDeficiencyDetailCeiling')}/> {getGarageDeficiencyDetailLabel(detail, 'ceiling')}
                                </span>
                              }
                            ):null
                          }
                          </div>
                          :null}

                          {garageDeficiency.garageDeficiencyName==='INTERIOR_WALLS'?<div><label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected. {generateTooltip('garageDeficiencyDetailInteriorWalls'+index2,'User to identify the type of deficiency of the item / component selected.')}</label>
                          <MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencyDetailInteriorWalls}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencyDetailInteriorWalls', v)}
                            options={garageDeficiencyDetailInteriorWallsEnum}
                          />
                          <br/>
                          {
                            garageDeficiency.garageDeficiencyDetailInteriorWalls?garageDeficiency.garageDeficiencyDetailInteriorWalls.map(
                              (detail, index3)=>{
                                return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGarageDeficienciesDetail(index, index2, index3, 'garageDeficiencyDetailInteriorWalls')}/> {getGarageDeficiencyDetailLabel(detail, 'interior_wall')}
                                </span>
                              }
                            ):null
                          }
                          </div>
                          :null}

                          <br/>
                          {garageDeficiency.garageDeficiencyName!=='NONE_OBSERVED'?<div><label>{!props.disabled?<font color="red">*</font>:null}Does the deficiency impact the safety, soundness, or structural integrity of the structure? {generateTooltip('garageDeficiencySeverity'+index,'User to select whether the deficient item does or does not impact safety, soundness, or structural integrity of the affected structural component. True = Deficiency impacts the safety, structural integrity or habitability of the structure. False = The deficiency does NOT affect the safety, structural integrity or soundness of the structure.')}</label></div>:null}
                          {garageDeficiency.garageDeficiencyName!=='NONE_OBSERVED'?<div><MySelect
                            type="select"
                            required={!props.disabled}
                            disabled={props.disabled}
                            style={props.disabled?disabledStyling:{}}
                            value={garageDeficiency.garageDeficiencySeverity}
                            onChange={(v)=>updateGarageDeficiencyDetail(index, index2, 'garageDeficiencySeverity', v)}
                            options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                          /></div>:null}
                          <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each deficiency observed. {generateTooltip('garageDeficiencyDescription'+index, 'User to provide a concise description of any deficiencies observed.')}</label>
                          <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={garageDeficiency.garageDeficiencyDescription} onChange={(e)=>updateGarageDeficiencyDetail(index,index2,'garageDeficiencyDescription', e.target.value)}/>
                          <br/>
                          <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of garage deficiency {generateTooltip('imageGarageDeficiency', 'Image(s) of all garage deficiencies identified. Image type name varies depending on the type of car storage update selected.')}</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={garageDeficiency.imageGarageDeficiency&&garageDeficiency.imageGarageDeficiency.length>0?" ":""}
                            required={!props.disabled}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, index2, 'imageGarageDeficiency', garageDeficiency.garageDeficiencyName+'_GARAGE_DEFICIENCY', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !garageDeficiency.imageGarageDeficiency?null:garageDeficiency.imageGarageDeficiency.map(
                                (photo, index3)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imageGarageDeficiency',index, index2,index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index2, index3, 'imageGarageDeficiency', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </CardBody>
                      </Card>
                      <br/>
                    </div>
                  }
                )}
                
                <Row>
                  <Col sm="6">
                    <label>{!props.disabled && (garage.garageType==='DETACHED_GARAGE' || garage.garageType==='ATTACHED_GARAGE' ||garage.garageType==='BUILTIN_GARAGE')?<font color="red">*</font>:null}Image(s) of outside of garage {generateTooltip('imageOutsideGarage', 'Image(s) of the outside of the garage. Should include the entry door. Note: If the garage was converted to living space, then evidence of this should be captured through this image. At a minimum provide images of the exterior of the garage, showing if the garage entry has been changed or removed. Image type name varies depending upon the name of the garage type.')}</label>
                    <br/>
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0, width:0 }}
                      value={garage.imageOutsideGarage&&garage.imageOutsideGarage.length>0?" ":""}
                      required={!props.disabled && (garage.garageType==='DETACHED_GARAGE' || garage.garageType==='ATTACHED_GARAGE' ||garage.garageType==='BUILTIN_GARAGE')}
                    />
                    <div>
                      <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageOutsideGarage', garage.garageType+'_EXTERIOR', 0)}} className="my-dropzone">
                      {
                        ({getRootProps, getInputProps}) => (
                          <div
                            {...getRootProps({
                              className: 'my-dropzone',
                            })}
                          >
                            <input {...getInputProps()} />
                            <center>Choose files to upload</center>
                          </div>
                        )
                      }
                      </Dropzone>
                      {
                        !garage.imageOutsideGarage?null:garage.imageOutsideGarage.map(
                          (photo, index2)=>{
                            return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                              <div>
                                <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageOutsideGarage',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                              </div>
                              <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                              {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageOutsideGarage', e.target.value)}/>
                              <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                            </div>
                          }
                        )
                      }
                    </div>
                  </Col>
                  <Col sm="6">
                    <label>{!props.disabled && (garage.garageType==='DETACHED_GARAGE' || garage.garageType==='ATTACHED_GARAGE' ||garage.garageType==='BUILTIN_GARAGE')?<font color="red">*</font>:null}Image(s) of inside of garage {generateTooltip('imageInsideGarage', 'Image(s) of the outside of the garage. Should include the entry door. Note: If the garage was converted to living space, then evidence of this should be captured through this image. At a minimum provide images of the exterior of the garage, showing if the garage entry has been changed or removed. Image type name varies depending upon the name of the garage type.')}</label>
                    <br/>
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0, width:0 }}
                      value={garage.imageInsideGarage&&garage.imageInsideGarage.length>0?" ":""}
                      required={!props.disabled && (garage.garageType==='DETACHED_GARAGE' || garage.garageType==='ATTACHED_GARAGE' ||garage.garageType==='BUILTIN_GARAGE')}
                    />
                    <div>
                      <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageInsideGarage', garage.garageType+'_INTERIOR', 0)}} className="my-dropzone">
                      {
                        ({getRootProps, getInputProps}) => (
                          <div
                            {...getRootProps({
                              className: 'my-dropzone',
                            })}
                          >
                            <input {...getInputProps()} />
                            <center>Choose files to upload</center>
                          </div>
                        )
                      }
                      </Dropzone>
                      {
                        !garage.imageInsideGarage?null:garage.imageInsideGarage.map(
                          (photo, index2)=>{
                            return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                              <div>
                                <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageInsideGarage',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                              </div>
                              <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                              {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageInsideGarage', e.target.value)}/>
                              <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                            </div>
                          }
                        )
                      }
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <br/>
          </div>
        )
      })
    }
    <br/>
    <br/>
  </div>
}


export default Garages;